import { MinzeElement } from "minze";

export interface TjSpiralIcon {
  dataWidth: number;
  dataHeight: number;
}

export class TjSpiralIcon extends MinzeElement {
  attrs = [
    "data-width",
    "data-height"
  ];
  html = () => `
    <svg width="${this.dataWidth || "107"}" height="${this.dataHeight || "47"}" viewBox="0 0 107 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.1103 44.9726L2.07941 40.7785M2.07941 40.7785L16.4249 16.5614M2.07941 40.7785C9.19076 38.5656 25.4954 32.1428 33.8232 24.155C44.233 14.1702 49.571 -2.19938 67.1308 3.97166C84.6907 10.1427 84.3176 38.9413 72.2073 40.9317C60.0971 42.922 44.1719 4.38814 75.1414 2.34871C92.0798 1.23326 105.093 25.3122 104.655 38.5272" stroke="#068FC3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
